interface TrustBarItem {
  icon: string;
  label: string;
  value: string;
}

interface TrustBarProps {
  items?: TrustBarItem[];
}

const defaultItems: TrustBarItem[] = [
  { icon: "ri-award-fill", label: "Years Serving London", value: "30+" },
  { icon: "ri-map-pin-2-fill", label: "Established", value: "Since 1994" },
  { icon: "ri-shield-check-fill", label: "Licensed & Insured", value: "Fully Covered" },
  { icon: "ri-leaf-fill", label: "In-House Crews", value: "No Sub-Trades" },
  { icon: "ri-home-heart-fill", label: "Service Region", value: "SW Ontario" },
];

export default function TrustBar({ items = defaultItems }: TrustBarProps) {
  return (
    <section className="bg-charcoal border-b border-stone-800">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
          {items.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 py-5 px-4 lg:px-6 ${
                i < items.length - 1 ? "lg:border-r border-stone-800/60" : ""
              }`}
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-rust-700/20 flex-shrink-0">
                <i className={`${item.icon} text-rust-400 text-sm`}></i>
              </div>
              <div>
                <p className="font-serif text-base font-bold text-white leading-none mb-0.5">
                  {item.value}
                </p>
                <p className="font-sans text-[10px] text-stone-500 tracking-[0.1em] uppercase leading-none">
                  {item.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
